import React from 'react';
import './layout.scss';

//Presentational component that displays text with styled more info beside it
function TextWithMoreInfo(props) {
  return(
    <>
    {props.text}
    <span className="aa-more-info"> {props.infoText}</span>
    </>
  );
}

export default TextWithMoreInfo;
